import { render, staticRenderFns } from "./m-addDuplicate.vue?vue&type=template&id=1151abd7&"
import script from "./m-addDuplicate.vue?vue&type=script&lang=js&"
export * from "./m-addDuplicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports